/* used within articles, not side bar, these do not have a border/shadow around them and do not link to the product
** TO IMPLEMENT:
**[alias]: the product alias
**[image]: the last number in the image path
**p: the product's name
		
<article-product-card alias="152528" image="542061">
	<p>Ultra Plush Blanket</p>
</article-product-card> 
*/

class ArticleProductCard extends HTMLElement {
	constructor() {
        super();
        
        this.prodName = this.querySelector("p").textContent;
	}
	
	get alias(){
		return this.getAttribute("alias");
	}
	
	set alias(value){
		this.setAttribute("alias", value);
	}
	
	get image(){
		return this.getAttribute("image");
	}
	
	set image(value){
		this.setAttribute("image", value);
	}
	
	connectedCallback() {		
		const style = document.createElement("style");
		style.textContent = `
			:host > div { 
				margin-bottom: 1.25rem;
			}
			picture { 
				display: block; 
				margin: 0.625rem 0.625rem 1.25rem 0.625rem; 
				text-align: center;
			}
			img	{ max-width: 100%; height: auto;}
			
			figure {	text-align: center; margin: 1.5rem 0;}
			figcaption 	{ text-align: center; margin-top: 0.625rem; }
		`;
		
		const articleProductCard = document.createElement("div");
		const html = `
			<link-element color="blue" link="/product/${this.alias}" padding="10">
			<figure>
				<picture>
					<source srcset="https://cdn.4imprint.com/prod/250/${this.image}.webp" type="image/webp">
					<source srcset="https://cdn.4imprint.com/prod/250/${this.image}.jpg" type="image/jpeg"> 
					<img width="250" height="250" src="https://cdn.4imprint.com/prod/250/${this.image}.jpg" alt="${this.prodName}">
				</picture>
				<figcaption>${this.prodName}</figcaption>
			</figure>
			</link-element>
		`;
		articleProductCard.innerHTML = html;
		
		this._shadowRoot = this.attachShadow({ mode: "open" });
		this._shadowRoot.appendChild(style);
        this._shadowRoot.appendChild(articleProductCard);
	}
	
	attributeChangedCallback(attrName, oldValue, newValue) {
		if (newValue !== oldValue) {
			switch (attrName) {
				case 'alias':
				case 'image':
					this[attrName] = this.getAttribute(attrName);
					break;
			}
		}
	}
}

customElements.define('article-product-card', ArticleProductCard);